import React from 'react';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { ErrorResponse } from 'legacy/common/utils/error';

import styles from '../../../../Checkout.module.scss';

type Props = {
  submitForm: () => void;
  totalNumberOfAnswers: number;
  totalNumberOfQuestions: number;
  error: ErrorResponse;
};

const ConfirmButton = ({
  submitForm,
  totalNumberOfAnswers,
  totalNumberOfQuestions,
  error
}: Props) => (
  <div className={styles.nextButtonWrapperMulti}>
    {error?.message && (
      <div className="text-error text-center pb-2">{error.message}</div>
    )}
    <Button
      type={ButtonType.Primary}
      onClick={submitForm}
      disabled={
        totalNumberOfAnswers < totalNumberOfQuestions || Boolean(error?.message)
      }
    >
      Send Request
    </Button>
  </div>
);

export default ConfirmButton;
